<template>
  <div class="n_list">
    <div class="n_card" v-for="(item,index) in invoiceList" :key="index">
      <div></div>
      <div class="n_invoicesn">订单编号：{{item.order_no}}</div>
      <div class="flex just_bettw n_pdnum">
        <p class="n_gifName">{{item.package_title}}</p>
        <p>
          <span class="n_fuaho">¥</span>
          <span class="n_price">{{item.package_price}}</span>
        </p>
      </div>
      <div class="flex just_bettw">
        <p class="n_redName">支持开具预付卡销售发票</p>
        <p class="n_hui">*{{item.num}}</p>
      </div>
      <div class="flex just_bettw n_mt30">
        <p></p>
        <p class="n_mutic">
          共 {{item.num}} 件商品，实付：
          <span class="n_muticNum">¥{{item.pay_money}}</span>
        </p>
      </div>
      <div class="flex just_bettw">
        <p></p>
        <p class="n_btn" @click="applyInvoiceFg(item.id)">申请开票</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    finished: {
      type: Boolean,
    },
    invoiceList: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
  },

  methods: {
    applyInvoiceFg(e) {
      this.$router.push({
        path: '/invoiceMachine',
        query: { order_ids: e, type: 1 },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.n_invoice {
  background: rgba(247, 248, 250, 1);
}
.n_list {
  padding: 20px;
}
.n_invoicesn {
  font-size: 26px;
  color: #333333;
  padding: 0 30px 23px 0;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.n_card {
  background: rgba(255, 255, 255, 1);
  padding: 27px 20px 30px 30px;
  margin-bottom: 20px;
}
.just_bettw {
  justify-content: space-between;
}
.align_center {
  align-items: center;
}
.n_btn {
  padding: 12px 40px;
  font-size: 30px;
  color: #ffffff;
  background: #f0240e;
  border-radius: 34px;
  margin-top: 20px;
}
.n_gifName {
  font-size: 28px;
  color: #333333;
}
.n_pdnum {
  margin: 28px 0 20px 0;
}
.n_price {
  font-size: 34px;
  font-weight: 700;
  color: #333333;
}
.n_fuaho {
  font-size: 28px;
  color: #333333;
}
.n_redName {
  font-size: 22px;
  color: #f0240e;
}
.n_hui {
  font-size: 24px;
  color: #999999;
}
.n_mutic {
  font-size: 26px;
  color: #343434;
}
.n_muticNum {
  font-size: 30px;
  color: #333333;
}
.n_mt30 {
  margin-top: 30px;
}
.n_flex {
  flex: 1;
}
.n_checjed {
  margin-right: 26px;
}
.n_tips {
  background: #fff2f3;
  border-radius: 14px;
  padding: 20px;
  margin-bottom: 20px;
}
.n_tips p {
  font-size: 24px;
  color: #f0240e;
}
</style>